import React, { FC } from 'react';
import TransparentButton from '../../shared/transparent-button/transparent-button';
import { PollResultsSlideContent } from '../../../constans/polls-constants';
import LoaderSpinner from '../../shared/custom-loader-spinner/loader-spinner';
import classNames from 'classnames';

interface IProps {
  openConfirmationModal: (value: boolean) => void;
  showButton: boolean;
  isLoading: boolean;
}

const ResultSlideButton: FC<IProps> = ({ openConfirmationModal, showButton, isLoading }): JSX.Element => (
  <>
    {showButton
      ? <TransparentButton
        customClasses={classNames({
          'result-slide-generate':  isLoading,
          'result-slide': !isLoading
        })}
        onClick={() => openConfirmationModal(true)}
        >
        {PollResultsSlideContent.ADD_RESULT_SLIDE}
        {isLoading && <LoaderSpinner/>}
      </TransparentButton>
      : <span className='result-slide-message'>{PollResultsSlideContent.RESULTS_SLIDE_ADDED}</span>
    }
  </>
);

export default ResultSlideButton;